import { summary } from './summary';
import { viewers } from './viewers';
import { views } from './views';

export const statistics = {
  summary,
  views,
  viewers,
};
